import * as Styled from '../BusinessProcessTree.styled';
import { InfoButton } from './InfoButton';
import { TFunction } from 'i18next';

export const renderProcessInventoryNode = (
  node: any,
  level: number,
  token: any,
  t: TFunction
) => {
  const labels = [
    t('businessProcess.l1'),
    t('businessProcess.l2'),
    t('businessProcess.l3'),
    t('businessProcess.l4')
  ];

  const types = ['processL1', 'processL2', 'processL3', 'processL4'] as const;

  const mappedLevel = level;

  return (
    <Styled.TreeNodeWrapper level={mappedLevel}>
      <Styled.TreeLabel token={token}>{labels[mappedLevel]}</Styled.TreeLabel>

      <Styled.TreeValue token={token} level={mappedLevel}>
        {node.label}
        <InfoButton type={types[mappedLevel]} item={node.raw} />
      </Styled.TreeValue>
    </Styled.TreeNodeWrapper>
  );
};
